import { Box, CardMedia, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import styled from "styled-components";
import GitHubCalendar from "react-github-calendar";
import "@fontsource/great-vibes";
const Gitinfo = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box style={{ padding: "12%" }} textAlign={"center"} id="github">
      <Typography
        variant="h4"
        color="black"
        style={{ fontFamily: "Great Vibes", color: "#1b242f" }}
      >
        Github
      </Typography>
      <div
        style={{
          width: "3rem",
          backgroundColor: "#1b242f",
          height: "1vh",
          margin: "auto",
          marginBottom: "2%",
        }}
        data-aos="fade-left"
      ></div>
      <MAIN>
        <CardMedia
          component="img"
          style={{
            height: "80%",
            width: "80%",
            margin: "1%",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
          image={
            "https://github-readme-stats.vercel.app/api?username=Tathagat017&theme=vue&hide_border=true&include_all_commits=true&count_private=true"
          }
          alt={"GitHub Stats"}
          align="center"
          className=".map"
          id="github-stats-card"
        />
        <CardMedia
          component="img"
          style={{
            height: "80%",
            width: "80%",
            margin: "1%",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
          image={
            "https://github-readme-streak-stats.herokuapp.com/?user=Tathagat017&theme=vue&hide_border=true"
          }
          alt={"GitHub Stats"}
          align="center"
          className=".map"
          id="github-streak-stats"
        />
        <CardMedia
          component="img"
          style={{
            height: "80%",
            width: "80%",
            margin: "1%",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
          image={
            "https://github-readme-stats.vercel.app/api/top-langs/?username=Tathagat017&theme=vue&hide_border=true&include_all_commits=true&count_private=true&layout=compact"
          }
          alt={"GitHub Stats"}
          align="center"
          className=".map"
          id="github-top-langs"
        />
        <CardMedia
          component="img"
          style={{
            height: "80%",
            width: "80%",
            margin: "1%",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
          image={
            "https://github-readme-activity-graph.cyclic.app/graph?username=tathagat017&theme=vue"
          }
          alt={"GitHub Stats"}
          align="center"
          className=".map"
        />
        <div style={{ padding: "1%" }} className=".map">
          <GitHubCalendar
            username="tathagat017"
            blockRadius={10}
            blockMargin={5}
            colorScheme="light"
          />
        </div>
      </MAIN>
    </Box>
  );
};

const MAIN = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  object-fit: contain;

  .map:hover {
    transform: scale(1.05);
    cursor: pointer;
  }
`;
export default Gitinfo;
